import { createTextComponent } from './createTextComponent';

export const H6 = createTextComponent({
  styleAs: 'h6',
  tag: 'h6',
});
